import Actors from '@/components/Actors/Actors.vue';
import ActorsDetail from '@/components/Actors/ActorsDetail.vue';

export default [
    {
        name: 'actors',
        path: '/actors',
        component: Actors,
        meta: { roles: ['role_administrator'] },
    },
    {
        name: 'actors-details',
        path: '/actors/detail/:id?',
        component: ActorsDetail,
        meta: { roles: ['role_administrator'] },
    },
];
